import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel, ShortModel } from '@data-layer/models/common';
import { ManagementAffiliateModel } from '../models/management/affiliates';

@Injectable({ providedIn: 'root' })
export class AffiliatesManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: PaginationSearchModel): Observable<PaginatedResultModel<ShortModel>> {
    return this.apiService.get<PaginatedResultModel<ShortModel>>(
      `${environment.url.prefixCustoms}v2/management/affiliates`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public get(id: number): Observable<ManagementAffiliateModel> {
    return this.apiService.get<ManagementAffiliateModel>(
      `${environment.url.prefixCustoms}v2/management/affiliates/${id}`,
      {},
      { isShowLoader: true },
    );
  }

  public create(payload: Partial<ShortModel>): Observable<ShortModel> {
    return this.apiService.post<ShortModel>(
      `${environment.url.prefixCustoms}v2/management/affiliates`,
      payload,
      {},
      { isShowLoader: true },
    );
  }

  public update(id: number, form: Partial<ShortModel>): Observable<ShortModel> {
    return this.apiService.put<ShortModel>(
      `${environment.url.prefixCustoms}v2/management/affiliates/${id}`,
      form,
      {},
      { isShowLoader: true },
    );
  }

  public attachContact(affiliateId: number, contactId: number): Observable<void> {
    return this.apiService.post<void>(
      `${environment.url.prefixCustoms}v2/management/affiliates/${affiliateId}/contacts/${contactId}`,
      {},
      {},
      { isShowLoader: true },
    );
  }

  public detachContact(affiliateId: number, contactId: number): Observable<void> {
    return this.apiService.delete<void>(
      `${environment.url.prefixCustoms}v2/management/affiliates/${affiliateId}/contacts/${contactId}`,
      {},
      { isShowLoader: true },
    );
  }
}
